import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { motion, AnimatePresence } from "framer-motion";

export default function ChamadosPorMotivo() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagina, setPagina] = useState(1); // 🔹 movi pra cima, fora do fluxo condicional

  useEffect(() => {
    const fetchDados = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/Dashboard/servico.php`
        );
        const data = await response.json();

        if (data.success && data.dados) {
          const adaptado = data.dados.map((item) => ({
            motivo: item.servico,
            total: item.total,
          }));
          setDados(adaptado);
        } else {
          console.error("Formato inesperado:", data);
        }
      } catch (err) {
        console.error("Erro ao buscar API:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDados();
  }, []);

  // 🔹 Agrupa motivos iguais somando os totais
  const agrupados = dados.reduce((acc, item) => {
    if (!acc[item.motivo]) {
      acc[item.motivo] = 0;
    }
    acc[item.motivo] += item.total;
    return acc;
  }, {});

  let dadosUnicos = Object.entries(agrupados).map(([motivo, total]) => ({
    motivo,
    total,
  }));

  dadosUnicos = dadosUnicos.sort((a, b) => b.total - a.total);

  const top10 = [...dadosUnicos];
  let i = 1;
  while (top10.length < 10) {
    top10.push({ motivo: `Sem dados ${i}`, total: 0 });
    i++;
  }
  top10.splice(10);

  // --- PAGINAÇÃO ---
  const porPagina = 5;
  const inicio = (pagina - 1) * porPagina;
  const fim = inicio + porPagina;
  const dadosPagina = top10.slice(inicio, fim);

  // 🔹 Aqui sim podemos condicionar o render
  if (loading) {
    return (
      <div className="p-6 bg-white rounded-sm shadow-lg shadow-black/30">
        Carregando...
      </div>
    );
  }

  return (
    <div className="p-6 bg-white rounded-sm shadow-lg shadow-black/30">
      <h3
        className="font-bold mb-4"
        style={{
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: "14px",
          color: "#777777",
        }}
      >
        Chamados por Tipo de Serviço (10+)
      </h3>

      <div className="h-[300px] relative overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={pagina}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
            className="absolute inset-0"
          >
            <ResponsiveContainer>
              <BarChart data={dadosPagina} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                <XAxis type="number" stroke="#6b7280" />
                <YAxis
                  dataKey="motivo"
                  type="category"
                  stroke="#6b7280"
                  width={150}
                />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "#f9fafb",
                    border: "1px solid #e5e7eb",
                    borderRadius: "6px",
                    color: "#111827",
                    fontFamily: "Inter, sans-serif",
                  }}
                />
                <Bar dataKey="total" fill="#8b5cf6" radius={[0, 4, 4, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Controles de paginação */}
      <div className="flex justify-center gap-2 mt-4">
        <button
          disabled={pagina === 1}
          onClick={() => setPagina(pagina - 1)}
          className="px-3 py-1 rounded bg-gray-200 disabled:opacity-50"
        >
          ←
        </button>
        <button
          onClick={() => setPagina(1)}
          className={`px-3 py-1 rounded ${
            pagina === 1 ? "bg-violet-500 text-white" : "bg-gray-200"
          }`}
        >
          1
        </button>
        <button
          onClick={() => setPagina(2)}
          className={`px-3 py-1 rounded ${
            pagina === 2 ? "bg-violet-500 text-white" : "bg-gray-200"
          }`}
        >
          2
        </button>
        <button
          disabled={pagina === 2}
          onClick={() => setPagina(pagina + 1)}
          className="px-3 py-1 rounded bg-gray-200 disabled:opacity-50"
        >
          →
        </button>
      </div>
    </div>
  );
}
